import * as types from './types'

export default {
  [types.MUTATE_MESSAGE]: (state, payload) => {
    state.message = payload
  }
}
